import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import {store} from "./store";

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  store.dispatch("inspectToken")
      .then((x)=>{
        if(store.state.jwt){
          return next();
        }
        else{
          return next("/login");
        }
      })
      .catch((e)=> {
        console.error(e)
        return next("/login");
      })
};

const ifAdmin = (to, from, next) => {
  store.dispatch("inspectToken")
      .then((x)=>{
        if(!store.state.jwt){
          return next("/login");
        }
        if(store.state.usergroup != "staff"){
          return next("/");
        }
        else{
          next()
        }
      })
      .catch((e)=> {
        console.error(e)
      })
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: ifAuthenticated
    },

    {
      path: '/archivos/:id',
      name: 'archivos',
      component: () => import(/* webpackChunkName: "about" */ './views/Memorias.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/bodega',
      name: 'bodega',
      component: () => import( './views/Bodega.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/bodega/:id',
      name: 'bodegaid',
      component: () => import('./views/Bodega.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/eventos',
      name: 'eventosmy',
      component: () => import(/* webpackChunkName: "about" */ './views/EventsMy.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/eventos/admin',
      name: 'eventosadmin',
      component: () => import(/* webpackChunkName: "about" */ './views/Events.vue'),
      beforeEnter: ifAuthenticated
    },
      {
      path: '/eventos/admin/:id',
      name: 'eventoadmin',
      component: () => import(/* webpackChunkName: "about" */ './views/admin/EventAdmin.vue'),
      beforeEnter: ifAdmin
    },
    {
      path: '/eventos/add',
      name: 'eventos',
      component: () => import(/* webpackChunkName: "about" */ './views/EventForm.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/eventos/admin/edit/:id',
      name: 'eventos',
      component: () => import(/* webpackChunkName: "about" */ './views/EventForm.vue'),
      beforeEnter: ifAdmin
    },
    {
      path: '/eventos/:id',
      name: 'eventosedit',
      component: () => import(/* webpackChunkName: "about" */ './views/Event.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/eventos/subscribir/:id',
      name: 'subscribe',
      component: () => import(/* webpackChunkName: "about" */ './views/Subscribe.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      beforeEnter: ifAuthenticated
    },
      {
      path: '/mi-cuenta',
      name: 'MiCuenta',
      component: () => import(/* webpackChunkName: "about" */ './views/auth/MiCuenta.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/bodegas',
      name: 'bodegas',
      component: () => import(/* webpackChunkName: "about" */ './views/BodegaListing.vue'),
      beforeEnter: ifAuthenticated
    },
      {
      path: '/memorias/add',
      name: 'memoriasform',
      component: () => import(/* webpackChunkName: "about" */ './views/admin/MemoriasForm.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/memorias/form/:id',
      name: 'memoriasformupdate',
      component: () => import(/* webpackChunkName: "about" */ './views/admin/MemoriasForm.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ './views/auth/Login.vue')
    },
    {
      path: '/salir',
      name: 'salir',
      component: () => import(/* webpackChunkName: "about" */ './views/auth/Salir.vue')
    },
    {
      path: '/lost-password',
      name: 'lostpassword',
      component: () => import(/* webpackChunkName: "about" */ './views/auth/Lostpassword.vue')
    },
    {
      path: '/recovery/:id',
      name: 'passwordrecovery',
      component: () => import(/* webpackChunkName: "about" */ './views/auth/PasswordRecovery.vue'),
      //beforeEnter: ifAuthenticated
    },
  ]
})
